/* eslint-disable react/prop-types */
import { message } from 'antd'
import axios from 'axios'
import dotObj from 'dot-object'
import { observer } from 'mobx-react-lite'
import path from 'path'
import React, { Fragment } from 'react'
import { Modal } from 'react-bootstrap'
import CookieConsent from 'react-cookie-consent'
import { Helmet } from 'react-helmet'
import { Route, Switch } from 'react-router-dom'
import { css } from 'styled-components'

import rootStoreContext from '../../../store.context'
import ee from '../../../utils/ee'
import { doQuery } from '../../../utils/gqlClient'
import queryString from '../../../utils/queryString'
import chatButtonStoreContext from '../../components/chatButton/store.context'
import chatConversationStoreContext from '../../components/chatConversation/store.context'
import Loading from '../../components/loading'
import chatConversationsStoreContext from './admin/components/chatConversations/store.context'
import { useContext } from './admin/components/drawer/context'
import { AppBridge } from './appBridge'
import { MarketingOptOut } from './marketingOptOut'


const Ecommerce = React.lazy(() => import(`./ecommerce`))
const Admin = React.lazy(() => import(`./admin`))
const Invoice = React.lazy(() => import(`./invoice`))

const Main = observer<any>(props => {

	let drawerStore = useContext()
	let chatButtonStore = React.useRef(React.useContext(chatButtonStoreContext)).current
	let rootStore = React.useRef(React.useContext(rootStoreContext)).current
	let chatConversationStore = React.useRef(React.useContext(chatConversationStoreContext)).current
	let chatConversationsStore = React.useRef(React.useContext(chatConversationsStoreContext)).current

	let appBridgeInterval: any

	const onAcceptCookies = React.useCallback(() => {
		localStorage.setItem(`${rootStore.laboratory._id}-cookies`, `true`)
	}, [rootStore])

	const areCookiesAccepted = React.useCallback(() => (
		localStorage.getItem(`${rootStore.laboratory._id}-cookies`) === `true`
		|| rootStore.getStringFlag(`appPlatform`) === `ios`
		|| rootStore.getStringFlag(`appPlatform`) === `android`
	), [rootStore])

	let _startAppBridge = () => {
		let callback = ({ data }: any) => {
			try {
				data = JSON.parse(data || `{}`)
				switch (data.action) {
					case `androidBackButton`: {
						ee.emit(`triggerBackButton`)
						try {
							window.ReactNativeWebView.postMessage(JSON.stringify({ action: `androidBackButtonReturn`, url: window.location.href }))
						} catch (e) { } // eslint-disable-line no-empty
						try {
							window.postMessage(JSON.stringify({ action: `androidBackButtonReturn`, url: window.location.href }), `*`)
						} catch (e) { } // eslint-disable-line no-empty
						break
					}
					case `setLoginData`: {
						const { userToken } = data
						if (!rootStore.laboratory.booleanFlags.get(`shared`)) return
						rootStore.setLoggedUserToken(userToken)
						break
					}
					case `setPlatform`: {
						localStorage.setItem(`pushConfig`, data.pushConfig)
						localStorage.setItem(`appPlatform`, data.platform)
						localStorage.setItem(`appVersion`, data.appVersion)
						rootStore.setNumberFlag(`appVersion`, data.appVersion)
						rootStore.setStringFlag(`appPlatform`, data.platform)
						// if (
						// 	data.platform === `ios`
						// 	&& !!data.isIphoneX
						// ) {
						// 	rootStore.setBooleanFlag(`isIphoneX`, true)
						// } else {
						// 	rootStore.setBooleanFlag(`isIphoneX`, false)
						// }
						if (appBridgeInterval) clearInterval(appBridgeInterval)
						break
					}
					case `checkCanOpenQRReader`: {
						if (
							rootStore.loggedUser.asAdmin.permissions.includes(`specialOwner`)
							|| rootStore.loggedUser.asAdmin.permissions.includes(`ordersRead`)
							|| rootStore.loggedUser.asAdmin.permissions.includes(`ordersReadOnlyCreatedBy`)
						) {
							try {
								window.ReactNativeWebView.postMessage(JSON.stringify({
									action: `openQRReader`
								}))
							} catch (e) { } // eslint-disable-line no-empty
							try {
								window.postMessage(JSON.stringify({
									action: `openQRReader`
								}), `*`)
							} catch (e) { } // eslint-disable-line no-empty
						}
						break
					}
					case `qrCodeRead`: {
						let qrData = (data.data || ``).split(`-`)
						switch (qrData[0]) {
							case `order`:
								ee.emit(`routerGoTo`, `/admin/ordens/ordem/qrCode/${qrData[1]}`)
								break
							default:
								try {
									window.ReactNativeWebView.postMessage(JSON.stringify({ action: `invalidQRCode` }))
								} catch (e) { } // eslint-disable-line no-empty
								try {
									window.postMessage(JSON.stringify({ action: `invalidQRCode` }), `*`)
								} catch (e) { } // eslint-disable-line no-empty
						}
						break
					}
				}
			} catch (e) { }
		}
		document.addEventListener(`message`, callback)
		window.onmessage = callback
		appBridgeInterval = setInterval(() => {
			try {
				window.ReactNativeWebView.postMessage(JSON.stringify({ action: `systemInit` }))
			} catch (e) { } // eslint-disable-line no-empty
			try {
				window.postMessage(JSON.stringify({ action: `systemInit` }), `*`)
			} catch (e) { } // eslint-disable-line no-empty
		}, 1000)
	}

	let _showOldVersionModalAdvise = () => {
		return (
			(
				rootStore.getStringFlag(`appPlatform`) === `ios`
				&& rootStore.laboratory.stringFlags.get(`iosStoreAppUrl`)
				&& rootStore.getNumberFlag(`appVersion`) < rootStore.laboratory.getNumberFlag(`iosAppVersion`)
			)
			|| (
				rootStore.getStringFlag(`appPlatform`) === `android`
				&& rootStore.laboratory.stringFlags.get(`androidStoreAppUrl`)
				&& rootStore.getNumberFlag(`appVersion`) < rootStore.laboratory.getNumberFlag(`androidAppVersion`)
			)
		)
	}

	let _openAppOnStore = () => {
		if (
			rootStore.getStringFlag(`appPlatform`) === `ios`
			&& rootStore.laboratory.stringFlags.get(`iosStoreAppUrl`)
		) {
			let url = rootStore.laboratory.getStringFlag(`iosStoreAppUrl`)
			try {
				window.ReactNativeWebView.postMessage(JSON.stringify({
					action: `openUrl`,
					url
				}))
			} catch (e) { } // eslint-disable-line no-empty
			try {
				window.postMessage(JSON.stringify({
					action: `openUrl`,
					url
				}), `*`)
			} catch (e) { } // eslint-disable-line no-empty
		}
		if (
			rootStore.getStringFlag(`appPlatform`) === `android`
			&& rootStore.laboratory.stringFlags.get(`androidStoreAppUrl`)
		) {
			let url = rootStore.laboratory.getStringFlag(`androidStoreAppUrl`)
			try {
				window.ReactNativeWebView.postMessage(JSON.stringify({
					action: `openUrl`,
					url
				}))
			} catch (e) { } // eslint-disable-line no-empty
			try {
				window.postMessage(JSON.stringify({
					action: `openUrl`,
					url
				}), `*`)
			} catch (e) { } // eslint-disable-line no-empty
		}
	}

	let _loadLoggedUser = () => {
		if (
			rootStore.loggedUserToken
			&& rootStore.laboratory._id
		) {
			// axios.get(
			// 	`https://api-sst-labconnect.labconnect.com.br/auth/logged`,
			// 	{
			// 		withCredentials: true,
			// 		headers: {
			// 			[`x-token`]: localStorage.getItem(`sst-token`)
			// 		}
			// 	}
			// )
			doQuery(`
				user: user_getLoggedByToken_public
			`)
				.then((data = {}) => {
					let { error, user } = data
					if (error) {
						message.warning(`Erro ao carregar usuário logado! Tente novamente...`)
						return
					}
					rootStore.setLoggedUser(user)
				})
		} else {
			rootStore.setLoggedUser(undefined)
		}
	}

	let _loadLaboratory = () => {
		doQuery(`
			lab: laboratory_identifyByHostName_public(
				hostname: "${rootStore.stringFlags.get(`hostname`)}"
			)
		`)
			.then((data = {}) => {
				let { lab, error } = data
				if (error) {
					if (error.match(/laboratoryNotFound/)) {
						window.location.href = `//labconnect.com.br`
						return
					}
					message.warning(`Erro ao carregar laboratório! Tente novamente...`)
					return
				}
				rootStore.setLaboratory(lab)
			})
	}

	React.useEffect(() => {
		if (!rootStore.laboratory.stringFlags.get(`googleAdsScripts`)) return
		const run = eval(rootStore.laboratory.getStringFlag(`googleAdsScripts`)) // eslint-disable-line
		if (typeof run === `function`) run()
	}, [rootStore.laboratory])

	React.useEffect(() => {
		_loadLoggedUser()
	}, [rootStore.laboratory]) // eslint-disable-line

	const identifyUserAtSmartlook = () => {
		if (
			rootStore.loggedUser
			&& (window as any).smartlook
		) {
			(window as any).smartlook(
				"identify",
				rootStore.loggedUser._id,
				{
					name: rootStore.loggedUser.name,
					email: rootStore.loggedUser.email,
				}
			)
		}
	}

	React.useEffect(() => {
		identifyUserAtSmartlook()
	}, [rootStore.loggedUser]) // eslint-disable-line

	React.useEffect(() => {
		if (rootStore.loggedUserToken) {
			localStorage.setItem(`loggedUserToken`, rootStore.loggedUserToken)
		} else {
			localStorage.removeItem(`loggedUserToken`)
		}
		_loadLoggedUser()
	}, [rootStore.loggedUserToken]) // eslint-disable-line

	React.useEffect(() => {
		_loadLaboratory()
		ee.on(`reloadLoggedUser`, () => _loadLoggedUser())
		ee.removeAllListeners(`triggerBackButton`)
		ee.on(`triggerBackButton`, () => {
			if (chatConversationStore.getBooleanFlag(`showConversation`)) {
				chatConversationStore.setBooleanFlag(`showConversation`, false)
				chatButtonStore.setBooleanFlag(`hideButton`, false)
				return
			}
			if (chatConversationsStore.getBooleanFlag(`showConversations`)) {
				chatConversationsStore.setBooleanFlag(`showConversations`, false)
				chatButtonStore.setBooleanFlag(`hideButton`, false)
				return
			}
			if (drawerStore.drawerOpened) return drawerStore.drawerOpened = false
			props.history.goBack()
		})
		ee.removeAllListeners(`routerReplaceTo`)
		ee.on(`routerReplaceTo`, url => {
			if (typeof url === `string`) {
				url = path.resolve(window.location.pathname, url)
				url = { search: props.location.search, pathname: url }
				props.history.replace(url)
			} else if (typeof url === `object`) {
				url.pathname = path.resolve(props.location.pathname, url.pathname)
				props.history.replace(url)
			}
		})
		ee.removeAllListeners(`routerGoTo`)
		ee.on(`routerGoTo`, url => {
			if (typeof url === `string`) {
				url = path.resolve(window.location.pathname, url)
				url = { search: props.location.search, pathname: url }
				props.history.push(url)
			} else if (typeof url === `object`) {
				url.pathname = path.resolve(window.location.pathname, url.pathname)
				props.history.push(url)
			}
		})
		ee.removeAllListeners(`labDoLogout`)
		ee.on(`labDoLogout`, () => {
			doQuery(`user_doLogout_public`)
				.then(() => {
					if (rootStore.laboratory.booleanFlags.get(`shared`)) {
						try {
							window.ReactNativeWebView.postMessage(JSON.stringify({ action: `doLogout` }))
						} catch (e) { } // eslint-disable-line no-empty
						try {
							window.postMessage(JSON.stringify({ action: `doLogout` }), `*`)
						} catch (e) { } // eslint-disable-line no-empty
					}
					rootStore.setLoggedUserToken(``)
					window.location.reload()
				})
		})
		ee.removeAllListeners(`labEcommerceGoToIdentification`)
		ee.on(`labEcommerceGoToIdentification`, (returnTo) => {
			let obj: any = { pathname: `/identificacao` }
			obj.search = queryString.parse({ props })
			if (returnTo) dotObj.str(`search.acao.voltarPara`, returnTo, obj)
			if (obj.search) obj.search = `?${queryString.stringify(obj.search)}`
			ee.emit(`routerGoTo`, obj)
		})
		_startAppBridge()

		return () => {
			ee.removeAllListeners(`labEcommerceGoToIdentification`)
			ee.removeAllListeners(`routerReplaceTo`)
			ee.removeAllListeners(`routerGoTo`)
			ee.removeAllListeners(`triggerBackButton`)
			ee.removeAllListeners(`labDoLogout`)
		}
	}, []) // eslint-disable-line

	return (
		rootStore.laboratory._id
			? (
				<Fragment>
					<Helmet>
						{
							rootStore.laboratory.getStringFlag(`headScript`)
								? <script>
									{rootStore.laboratory.getStringFlag(`headScript`)}
								</script>
								: undefined
						}
						<meta
							name={`description`}
							content={rootStore.laboratory.settings.aboutUs.onlyText}
						/>
						<title>{rootStore.laboratory.displayName}</title>
					</Helmet>
					{
						rootStore.laboratory.getStringFlag(`bodyScript`)
							? <div dangerouslySetInnerHTML={{ __html: rootStore.laboratory.getStringFlag(`bodyScript`) }} />
							: undefined
					}
					<span>
						<style>
							{css`
								.border-color-primary-main{
									border-color: ${rootStore.laboratory.colors.primary.main} !important;
								}
								.border-color-primary-lighter{
									border-color: ${rootStore.laboratory.colors.primary.lighter} !important;
								}
								.border-color-primary-darker{
									border-color: ${rootStore.laboratory.colors.primary.darker} !important;
								}

								.border-color-secondary-main{
									border-color: ${rootStore.laboratory.colors.secondary.main} !important;
								}
								.border-color-secondary-lighter{
									border-color: ${rootStore.laboratory.colors.secondary.lighter} !important;
								}
								.border-color-secondary-darker{
									border-color: ${rootStore.laboratory.colors.secondary.darker} !important;
								}

								.background-color-primary-main{
									background-color: ${rootStore.laboratory.colors.primary.main} !important;
								}
								.background-color-primary-lighter{
									background-color: ${rootStore.laboratory.colors.primary.lighter} !important;
								}
								.background-color-primary-darker{
									background-color: ${rootStore.laboratory.colors.primary.darker} !important;
								}
								
								.background-color-secondary-main{
									background-color: ${rootStore.laboratory.colors.secondary.main} !important;
								}
								.background-color-secondary-lighter{
									background-color: ${rootStore.laboratory.colors.secondary.lighter} !important;
								}
								.background-color-secondary-darker{
									background-color: ${rootStore.laboratory.colors.secondary.darker} !important;
								}

								.color-primary-main{
									color: ${rootStore.laboratory.colors.primary.main} !important;
								}
								.color-primary-lighter{
									color: ${rootStore.laboratory.colors.primary.lighter} !important;
								}
								.color-primary-darker{
									color: ${rootStore.laboratory.colors.primary.darker} !important;
								}
								.color-primary-text{
									color: ${rootStore.laboratory.colors.primary.text} !important;
								}

								.color-secondary-main{
									color: ${rootStore.laboratory.colors.secondary.main} !important;
								}
								.color-secondary-lighter{
									color: ${rootStore.laboratory.colors.secondary.lighter} !important;
								}
								.color-secondary-darker{
									color: ${rootStore.laboratory.colors.secondary.darker} !important;
								}
								.color-secondary-text{
									color: ${rootStore.laboratory.colors.secondary.text} !important;
								}
							`}
						</style>
					</span>
					<Switch>
						{
							(
								rootStore.loggedUser._id
								&& rootStore.loggedUser.booleanFlags.get(`termsOfUseAccepted`)
								&& rootStore.loggedUser.booleanFlags.get(`emailConfirmed`)
								&& !rootStore.loggedUser.getBooleanFlag(`waitingLabManualApproving`)
							)
								// @ts-ignore
								? <Route path={path.join(`/`, `admin`)} component={Admin} />
								: undefined
						}
						{/* @ts-ignore */}
						<Route path={path.join(`/`, `fatura`, `:invoiceId`)} component={Invoice} />
						{/* @ts-ignore */}
						<Route path={path.join(`/`, `descadastrarEmailMarketing`)} component={MarketingOptOut} />
						{/* @ts-ignore */}
						<Route path={path.join(`/`, `app`)} component={AppBridge} />
						{/* @ts-ignore */}
						<Route path={`/`} component={Ecommerce} />
					</Switch>
					<Modal
						backdrop={`static`}
						show={_showOldVersionModalAdvise()}
						className={`d-flex align-tems-center justify-content-center pt-5`}
					>
						<Modal.Header className={`p-2`}>
							<h5 className="m-2">
								{`Atualização Necessária`}
							</h5>
						</Modal.Header>
						<Modal.Body className={`p-2`}>
							{rootStore.getNumberFlag(`appVersion`) < 2 && (
								<Fragment>
									<div
										className={`m-2`}
										style={{
											backgroundImage: `url(/assets/icons/ecommerce/update.png)`,
											backgroundSize: `contain`,
											backgroundPosition: `center`,
											backgroundRepeat: `no-repeat`,
											height: 200
										}}
									/>
									<p className={`p-2 text-center`}>
										{`Caro usuário, existe uma nova versão mais segura e mais rápida deste aplicativo disponível na ${(
											rootStore.getStringFlag(`appPlatform`) === `ios`
												? `App Store`
												: `Google Play`
										)}!`}
									</p>
									<p className={`p-2 text-center`}>
										{`Utilize o botão abaixo e atualize agora mesmo...`}
									</p>
									<div className="p-2">
										{/* @ts-ignore */}
										<button
											className="btn btn-block btn-primary"
											onClick={_openAppOnStore}
										>
											{rootStore.getStringFlag(`appPlatform`) === `ios`
												? `Abrir App Store`
												: `Abrir Google Play`
											}
										</button>
									</div>
								</Fragment>
							)}
						</Modal.Body>
					</Modal>
					{
						!areCookiesAccepted()
						&& (
							// @ts-ignore 
							<CookieConsent
								location="bottom"
								buttonText="Aceito"
								onAccept={onAcceptCookies}
								cookieName={`${rootStore.laboratory._id}-cookie`}
								expires={1825}
								style={{ background: `white`, color: `black` }}
								buttonStyle={{ background: `black`, color: `white` }}
							>
								<b>{`${rootStore.laboratory.displayName}`}</b>
								{` utiliza cookies para lhe proporcionar a melhor experiência online.`}
								<br />
								{`Informe-nos se concorda com estes termos.`}
								<br />
								<br />
								<a href={`/termos`}>{`Ler a Política de Privacidade`}</a>
							</CookieConsent>
						)
					}
				</Fragment>
			)
			: (
				<Loading show={true} />
			)
	)
})

export default Main